<template>
    <div>
        <p class="label">Délégué</p>
        <MultiplePickerInput :value="value" @input="onInput" :items="items" v-bind="$attrs" />
    </div>

</template>

<script>
  import MultiplePickerInput from '@/components/inputs/MultiplePickerInput.vue';

  export default {
    name: "DelegatePickerInput",
    components: {
      MultiplePickerInput,
    },
    props: {
      value: Array
    },
    data() {
      return {
        items: [
          {
            'name': 'Oui',
            'id': 1
          },
          {
            'name': 'Non',
            'id': 0
          }
        ],
      }
    },
    methods: {
      onInput(event) {
        this.$emit('input', event);
      }
    },
  }
</script>

<style scoped>

</style>
